import { Fee } from "./fee-types";
import { AvailableUnitExtended } from "./property-types";

export interface FeeTransparencyState {
  selectedMoveInDate: string;
  selectedLeaseTerm: string;
  selectedUnit: AvailableUnitExtended;
  numberOfApplicants: number;
  selectedBaseRent: number;
  allFees: Fee[];
}

export enum FeeActions {
  INCREMENT = "increment",
  DECREMENT = "decrement",
  RESET = "reset",
}
export interface UpdateSelectedFeeProps {
  selectedFee?: Fee;
  action: FeeActions;
  changeAmount: number;
}

export enum FeeStateActions {
  SET_SELECTED_MOVE_IN_DATE = "SET_SELECTED_MOVE_IN_DATE",
  SET_SELECTED_LEASE_TERM = "SET_SELECTED_LEASE_TERM",
  SET_NUMBER_OF_APPLICANTS = "SET_NUMBER_OF_APPLICANTS",
  CLEAR_STATE = "CLEAR_STATE",
  SET_ALL_FEES = "SET_ALL_FEES",
  UPDATE_FEES = "UPDATE_ACTIVE_FEES",
  SET_SELECTED_UNIT = "SET_SELECTED_UNIT",
}

export type DispatchFunction = (action: {
  type: FeeStateActions;
  payload: any;
}) => void;

export type SetLeaseDetails = {
  setSelectedMoveInDate: (
    dispatch: DispatchFunction,
  ) => (selectedMoveInDate: string) => void;
  setSelectedLeaseTerm: (
    dispatch: DispatchFunction,
  ) => (selectedLeaseTerm: string) => void;
};

export type FeeStateProps = {
  feeState: FeeTransparencyState;
  dispatch: DispatchFunction;
};
